// extracted by mini-css-extract-plugin
module.exports = {"socialIcons":"SocialShare_socialIcons__2odcw","socialHeading":"SocialShare_socialHeading__B7JNJ","socialText":"SocialShare_socialText__3tOza"};